/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { isUndefined } from "utils/lodashUtils";

export class PreviewStore {
  @observable width;
  @observable ariaLiveMessage;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.width = `calc(100%)`;
    this.ariaLiveMessage = {};
  }

  @action.bound
  setDimensions({ width }) {
    if (!isUndefined(width)) {
      this.width = width;
    }
  }

  @action
  setAriaLiveMessage(message) {
    this.ariaLiveMessage = message;
  }
}
